/**
 * @module app.cm
 */

import { autoinject } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';

@autoinject()
export class ManageReferredByPage {

    ////****************** Fields and Properties ************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly logger: AppLogger) {
        this.logger.source = this;
    }

    ////****************** Element References ***************************************////

    ////****************** Functions ************************************************////

}
